import { useEffect, useState } from "react";
import axios from "axios";
import { apiURI, authErrorRedirect, useAuthInfo } from "..";
import { useNavigate } from "react-router-dom";

export function useFormDropdownFields() {
  const [executiveChefList, setExecutiveChefList] = useState([]);
  const [hodList, setHodList] = useState([]);
  const [endUserLocations, setEndUserLocations] = useState([]);
  const [buNumbers, setBuNumbers] = useState([]);
  // Access the decoded authentication information
  const decoded = useAuthInfo();
  const [errors, setErrors] = useState();
  const history = useNavigate();

  useEffect(() => {
    axios
      .get(`${apiURI}/form/getFormDropdownFields`)
      .then((response) => {
        const executiveChefListArray = [];
        const HODListArray = [];
        const endUserLocationsArray = [];
        const BUNumbersArray = [];
        if (decoded.role === "procurement") {
          response.data.forEach((item) => {
            executiveChefListArray.push(...item.executiveChefList);
            HODListArray.push(...item.hodList);
            endUserLocationsArray.push(...item.endUserLocations);
            BUNumbersArray.push(...item.buNumbers);
          });
        } else {
          // Find the object matching the user's organization.
          const organizationData = response.data.find(
            (item) => item.organizationID === decoded.organization,
          );
          // Guard against a missing org so the dropdowns degrade to empty
          // instead of throwing and blanking the whole form.
          if (organizationData) {
            executiveChefListArray.push(...(organizationData.executiveChefList ?? []));
            HODListArray.push(...(organizationData.hodList ?? []));
            endUserLocationsArray.push(...(organizationData.endUserLocations ?? []));
            BUNumbersArray.push(...(organizationData.buNumbers ?? []));
          }
        }
        setExecutiveChefList(executiveChefListArray);
        setHodList(HODListArray);
        setEndUserLocations(endUserLocationsArray);
        setBuNumbers(BUNumbersArray);
      })
      .catch((error) => {
        setErrors();
        setErrors({ response: error.response?.data });
        authErrorRedirect(error.response?.data, history);
      });
    // eslint-disable-next-line no-console
  }, []);

  errors && console.log(errors);

  return { executiveChefList, hodList, endUserLocations, buNumbers };
}
